
import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) =>
(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M10.0003 10.8332C10.4606 10.8332 10.8337 10.4601 10.8337 9.99984C10.8337 9.5396 10.4606 9.1665 10.0003 9.1665C9.54009 9.1665 9.16699 9.5396 9.16699 9.99984C9.16699 10.4601 9.54009 10.8332 10.0003 10.8332Z"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.8333 10.8332C16.2936 10.8332 16.6667 10.4601 16.6667 9.99984C16.6667 9.5396 16.2936 9.1665 15.8333 9.1665C15.3731 9.1665 15 9.5396 15 9.99984C15 10.4601 15.3731 10.8332 15.8333 10.8332Z"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.16634 10.8332C4.62658 10.8332 4.99967 10.4601 4.99967 9.99984C4.99967 9.5396 4.62658 9.1665 4.16634 9.1665C3.7061 9.1665 3.33301 9.5396 3.33301 9.99984C3.33301 10.4601 3.7061 10.8332 4.16634 10.8332Z"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);


export default Icon;
